import React, { useState } from 'react';

const GenerationCard = ({
  result,
  drafts,
  handleDraftChange,
  generatedResults,
  handleGenerate,
  generationLoading,
}) => {
  const [expandedGeneratedIndex, setExpandedGeneratedIndex] = useState(null);

  const handleToggleGenerated = (index) => {
    setExpandedGeneratedIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl border border-blue-200 dark:border-blue-800" data-testid="generationCard-container">
      <div className="flex items-center gap-3 mb-4">
        <span className="material-symbols-outlined text-blue-600 dark:text-blue-400">forum</span>
        <h3 className="font-semibold text-text-light-primary dark:text-text-dark-primary text-lg">Engage with {result.username}</h3>
      </div>
      <textarea
        value={drafts[result.permalink] || ''}
        onChange={(e) => handleDraftChange(result.permalink, e.target.value)}
        placeholder="Write your message or instructions for the AI..."
        className="w-full bg-container-light dark:bg-container-dark border border-border-light dark:border-border-dark rounded-md p-2 text-sm mb-4 focus:ring-0 focus:border-[var(--color-primary-accent)]"
        data-testid="generationCard-draftTextarea"
      />
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => handleGenerate(result, 'dm')} disabled={generationLoading} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="generationCard-generateDmButton">
          {generationLoading ? (
            <div className="spinner"></div>
          ) : (
            <>
              <span className="material-symbols-outlined text-base">send</span>
              Generate DM
            </>
          )}
        </button>
        <button onClick={() => handleGenerate(result, 'comment')} disabled={generationLoading} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="generationCard-generateCommentButton">
          {generationLoading ? (
            <div className="spinner"></div>
          ) : (
            <>
              <span className="material-symbols-outlined text-base">send</span>
              Generate Comment
            </>
          )}
        </button>
      </div>
      <div className="space-y-4">
        {generatedResults[result.permalink]?.results?.map((item, i) => {
            const isGeneratedExpanded = expandedGeneratedIndex === i;
            return (
              <div key={i} className="p-4 rounded-lg border border-border-light dark:border-border-dark bg-container-light dark:bg-container-dark">
                <div className="relative">
                  <p className={`text-text-light-secondary dark:text-text-dark-secondary leading-relaxed ${!isGeneratedExpanded ? 'line-clamp-3' : ''}`}>
                    {item.content}
                  </p>
                  {isGeneratedExpanded && (
                    <>
                      <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary italic border-l-2 border-blue-300 pl-3 my-3">
                        <strong className="font-semibold">Description:</strong> {item.description}
                      </p>
                      {item.source_text && (
                        <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary italic border-l-2 border-blue-300 pl-3 my-3">
                          <strong className="font-semibold">Citation:</strong> "{item.source_text}"
                        </p>
                      )}
                    </>
                  )}
                  <button onClick={() => handleToggleGenerated(i)} className="absolute bottom-0 right-0 bg-transparent !bg-transparent text-[var(--color-primary-accent)] hover:bg-transparent !hover:bg-transparent transition-none flex-shrink-0 p-1 min-w-[unset] min-h-[unset] border-none outline-none" data-testid="generationCard-expandCollapseButton">
                    <span className="material-symbols-outlined text-xl">
                      {isGeneratedExpanded ? 'expand_less' : 'expand_more'}
                    </span>
                  </button>
                </div>
                <button onClick={() => navigator.clipboard.writeText(item.content)} className="mt-4 bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="generationCard-copyButton">
                  <span className="material-symbols-outlined text-base">content_copy</span>
                  Copy
                </button>
              </div>
            )
        })}
      </div>
    </div>
  );
};

export default GenerationCard;
